import type { IBasicVideo, IEvent, IPlaylist } from "~/types";
import type { IPlayerState } from "~~/modules/pixellot-sdk";

import type { VideoJsPlayer as IPixellotPlayer } from "@pixellot/web-sdk";

const [provideFloatingPlayer, useFloatingPlayer] = useSingleton<{
  open: (
    v: IPlaylist | IEvent | IBasicVideo | null,
    options?: {
      /**
       * We expect event to be passed only when opening system playlists
       */
      event?: IEvent;
    }
  ) => void;
  close: () => void;
  togglePiPMode: () => void;
  video: Ref<IEvent | IBasicVideo | null>;
  player: Ref<IPixellotPlayer | null>;
  playerState: Ref<IPlayerState | null>;
  isDeleted: Ref<boolean>;
}>();

export { provideFloatingPlayer, useFloatingPlayer };
